import React from "react";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { IMAGES } from "../constants/images";

const BreadcrumbSection = ({ breadcrumbs,setShowFollowers }) => {
  const navigate = useNavigate();

  return (
    <section
      className="banner_section breadcrumb_section"
      style={{ backgroundImage: `url(${IMAGES.Breadcrumb_Img})` }}
    >
      <Container>
        <Row>
          <Col md={12}>
            <Breadcrumb>
              <Breadcrumb.Item href="#" onClick={() => navigate("/")}>
                Home
              </Breadcrumb.Item>
              {breadcrumbs.map((breadcrumb, index) => (
                <React.Fragment key={index}>
                  <Breadcrumb.Item
                  style={{textAlign:"left"}}
                    href={breadcrumb.link ? "#" : undefined}
                    active={!breadcrumb.link}
                    onClick={
                      breadcrumb.link
                        ? () =>
                         {   navigate(breadcrumb.link, {
                              state: breadcrumb.state || {}, // ✅ pass state here
                            })
                            if(setShowFollowers){
                              setShowFollowers(false)
                            }
                          }
                        : undefined
                    }
                  >
                    {breadcrumb.title}
                  </Breadcrumb.Item>

                  {/* Optional second level (if needed) */}
                  {breadcrumb.link1 && (
                    <Breadcrumb.Item
                      onClick={() => navigate(breadcrumb.link1)}
                    >
                      {breadcrumb.link1}
                    </Breadcrumb.Item>
                  )}
                </React.Fragment>
              ))}
            </Breadcrumb>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default BreadcrumbSection;
